// export const BASE_API = "http://192.168.1.20:9017";
export const BASE_API = "https://www.deldiadistribuciones.nom.pe";
export const TOKEN = "token";
